export default "__VITE_ASSET__CQgVgVwi__"